module.exports = __webpack_public_path__ + "img/TIMELINE.f9ebd6fa.svg";